export default "__VITE_ASSET__DAXEOD_B__"